// ConfirmModal.js
import React from "react";
import { Modal, Button } from "react-bootstrap";

type ConfirmModalProps = {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  body?: React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  confirmVariant?: string;
  cancelVariant?: string;
};

const ModalBasic: React.FC<ConfirmModalProps> = ({
  show,
  onClose,
  onConfirm,
  title = "Confirmar",
  body = "¿Estás seguro?",
  confirmText = "Aceptar",
  cancelText = "Cancelar",
  confirmVariant = "primary",
  cancelVariant = "secondary",
}) => {
  return (
    <Modal show={show} onHide={onClose} animation={false}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{body}</Modal.Body>
      <Modal.Footer>
        <Button variant={cancelVariant} onClick={onClose}>
          {cancelText}
        </Button>
        <Button variant={confirmVariant} onClick={onConfirm}>
          {confirmText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalBasic;
